// Redirect old category handles to new ones
(function() {
  var defined_redirects = {
    'debloat-vaginal-probiotics': 'detox',
    'daily-gut-health': 'gut-health',
    'sports-essentials': 'workout-and-performance',
    'weight-loss-body-shaping': 'weight-loss',
    'collagen-hair-skin-nails': 'skin-hair-and-glow',
    'health-supplements': 'daily-wellness',
    'sleep-and-wellbeing': 'stress-and-sleep',
    'whey-aminos-and-proteins': 'energy-and-focus',
    'shaping-supplements': 'muscle-and-strength',
    'functional-foods': 'snacks-and-functional-food'
  };
  var path = window.location.pathname;
  var parts = path.split('/');
  var lastSegment = parts[parts.length - 1];
  if (path.indexOf('/collections/shop-fitness/') !== -1 && defined_redirects[lastSegment]) {
    parts[parts.length - 1] = defined_redirects[lastSegment];
    window.location.replace(parts.join('/') + window.location.search);
  }
})();

window.filterSettingsNutrition = {
  category: ['best-seller', 'gut-health', 'muscle-and-strength', 'weight-loss', 'workout-and-performance', 'womens-health', 'skin-hair-and-glow', 'stress-and-sleep', 'general-health', 'detox', 'snacks-and-functional-food', 'accessories', 'new'],
  discount: ['basics','10-40off', '30off',  '40off',  '50off', '60off', '70off', '75off', '40-50off', '50-60off', '60-70off', '70-80off'],
  type: ['capsules','gummies','powder','protein-snacks','protein'],
  other: ['new', 'wishlist', 'sale', /*'bundles',*/ 'best-seller','deal-of-the-day-2','price10','price10-20','price20-40','price40']
};

window.wbShopFilter.enableDisplayActiveFilters();
window.wbShopFilter.initCategoryFilter(filterSettingsNutrition.category);

$(document).ready(function() {
  
  var $p_filter = $('.wb-shop-filter-desktop');
  
  var $p_shop_filter__checkbox_discount = $p_filter.find('.wb-shop-filter__checkbox-discount');
  var $p_filter_checkboxes_blackfriday = $p_filter.find('.wb-shop-filter__checkbox-blackfriday');
  var $p_filter_checkboxes_range = $p_filter.find('.wb-shop-filter__checkbox-range');
  var $p_filter_checkboxes_category = $p_filter.find('.wb-shop-filter__checkbox-category');
  var $p_filter_checkboxes_collection = $p_filter.find('.wb-shop-filter__checkbox-collection');
  var $p_filter_checkboxes_key = $p_filter.find('.wb-shop-filter__checkbox-key');
  var $p_filter_checkboxes_athletes = $p_filter.find('.wb-shop-filter__checkbox-athletes');
  var $p_filter_checkboxes_type = $p_filter.find('.wb-shop-filter__checkbox-type');
  var $p_filter_checkboxes_other = $p_filter.find('.wb-shop-filter__checkbox-other');
  var $p_filter_list = document.querySelector('.wb-shop-filter-desktop__list');
  var categoryFilterList = ['best-seller', 'gut-health', 'muscle-and-strength', 'weight-loss', 'workout-and-performance', 'womens-health', 'skin-hair-and-glow', 'stress-and-sleep', 'general-health', 'detox', 'snacks-and-functional-food', 'accessories', 'new'];

  $p_shop_filter__checkbox_discount.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, $p_shop_filter__checkbox_discount, window.filterSettingsNutrition.discount));
  });
  $p_filter_checkboxes_blackfriday.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, $p_filter_checkboxes_blackfriday, window.filterSettingsNutrition.discount));
  });
  $p_filter_checkboxes_range.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, $p_filter_checkboxes_range, window.filterSettingsNutrition.category));
  });
  $p_filter_checkboxes_category.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, $p_filter_checkboxes_category, window.filterSettingsNutrition.category));
  });
  $p_filter_checkboxes_collection.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, null, null));
  });
  $p_filter_checkboxes_key.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, null, null));
  });
  $p_filter_checkboxes_athletes.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, null, null));
  });
  $p_filter_checkboxes_type.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, null, null));
  });
  $p_filter_checkboxes_other.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, null, null));
  });

  window.wbShopFilter.initMainFilterClass();
});
